
<div class="col-xs-10 m-o p-0" *ngIf="parseObject">
  <input-select [parseObj]="parseObject" [name]="name" [options]="addressOptions" [disabled]="disableAddressEdit" required="true"></input-select>
</div>
<div class="ml-2 col-xs-2"><i class="fa fa-plus-square-o" *ngIf="!disableAddressEdit" (click)="openAddressEditPopup(appConfig.Shared.Actions.new)"></i><i class="fa fa-pencil-square-o ml-2" *ngIf="parseObject && parseObject.get('addressBook') && !disableAddressEdit" (click)="openAddressEditPopup(appConfig.Shared.Actions.edit)"></i></div>
